import React from 'react';
import cn from 'classname';

import Row from './row';
import ShowMoreTrigger from './show-more-trigger';
import './main.less';

const Table = props => {
	const { table, intl, sortColumn, changeSort }  = props;

	return (
		<div className="table-container guarant-approve-requests-table">
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium sticky-top-0">
					<tr>
						{
							table.headers
								.map((header, i) =>
									<th
										key={i}
										className={cn({
											[header.className]: true,
											[sortColumn.direction]: Array.isArray(header.index)
												? header.index.includes(sortColumn.col)
												: sortColumn.col === header.index,
											'active': Array.isArray(header.index)
												? header.index.includes(sortColumn.col)
												: sortColumn.col === header.index
										})}
										onClick={changeSort.bind(null, header)}
									>
										{Array.isArray(header.title)
											? header.title.map(
												(item, index) =>
													<span
														key={index}
														onClick={changeSort.bind(null, { index: header.index[index], isSortable: true })}
													>
														{intl(item)}/
													</span>
											)
											: <span>{intl(header.title)}</span>
										}
									</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						<Row key={i} row={row} {...props} />
					)}
					<tr><td className="text-center fixed-col" colSpan={1}>
						<ShowMoreTrigger
							callBack={props.paginateData}
							isLoading={props.pagination.isLoading}
							isLoadedAll={props.pagination.isLoadedAll}
							compDefault={<span id="last-row">Show more</span>}
							compLoading={<span id="last-row">Loading</span>}
							compLoadedAll={null}
						/>
					</td>
					</tr>

				</tbody>
			</table>
		</div>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/guarant-approve-register/list/components/table/main.js